import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, getToken, clearToken } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getToken()) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch((err) => {
        if (err?.response?.status !== 401) {
          console.error("auth/me failed:", err);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("logout failed:", err);
    }
    clearToken();
    setUser(null);
    window.location.href = "/login";
  }, []);

  const value = useMemo(
    () => ({ user, setUser, loading, logout }),
    [user, loading, logout]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

const ADMIN_ROLES = ["super_admin", "ops_manager", "supervisor"];
const CLIENT_ROLES = ["client_admin", "client_viewer"];

export const homeForRole = (role) => {
  if (ADMIN_ROLES.includes(role)) return "/admin";
  if (role === "guard") return "/guard";
  if (CLIENT_ROLES.includes(role)) return "/portal";
  return "/login";
};
